import { render, staticRenderFns } from "./assist-manage-audit.vue?vue&type=template&id=b819049a&scoped=true"
import script from "./assist-manage-audit.vue?vue&type=script&lang=ts"
export * from "./assist-manage-audit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b819049a",
  null
  
)

export default component.exports